<script lang="ts" setup>
import { Popup, showLoadingToast, showSuccessToast } from "vant";
import { computed, ref } from "vue";
import { GAL_GAME_URL_PREFIX } from "@/stores/galGameEditor";
import { copyToClipboard } from "@/modules/common";
import i18n from "@/locales";
import { ApiBuildStoryGame } from "@/apis/story-game";
import { Story } from "@/types/entity";

interface FastForwardParams {
  nodeId?: number;
  dialogId?: number;
}

// Props
const props = defineProps<{
  id: number;
  uuid: string; // galgame.uuid
  story: Story;
  withBuild?: boolean;
}>();

// States
const show = ref(false);
const fastForward = ref<null | FastForwardParams>(null); // galgame.dialogId
const url = computed(() => {
  const baseUrl = `${GAL_GAME_URL_PREFIX}?uuid=${props.uuid}&type=story`;
  if (fastForward.value) {
    const { dialogId, nodeId } = fastForward.value;
    let fullUrl = `${baseUrl}`;
    if (dialogId) fullUrl += `&dialogId=${dialogId}`;
    if (nodeId) fullUrl += `&nodeId=${nodeId}`;
    return fullUrl;
  } else {
    return baseUrl;
  }
});
const mute = computed(() => (show.value ? "autoplay" : "autoplay;muted"));

// Lifecycle

// Methods
const startPreview = async (params?: FastForwardParams) => {
  const loading = showLoadingToast({
    message: i18n.global.t("Message.loading"),
  });
  if (props.withBuild) await ApiBuildStoryGame(props.id);
  if (params) {
    fastForward.value = params;
  } else {
    fastForward.value = null;
  }
  show.value = true;
  loading.close();
};
// Emit
defineExpose({
  startPreview,
});

export interface StoryScenePreviewPopupInstance {
  startPreview: typeof startPreview;
}

const clickCopy = async () => {
  copyToClipboard(`${GAL_GAME_URL_PREFIX}?uuid=${props.uuid}&type=story`);
  showSuccessToast({ message: i18n.global.t("Message.copySuccessful") });
};

const showPublishModal = ref(false);
const clickShareToMoments = () => {};
</script>
<template>
  <popup
    v-if="show"
    v-model:show="show"
    class="flex flex-col items-center gap-2 h-[90%] galgame-preview-popup pt-2"
    position="bottom"
    round
  >
    <div class="flex gap-2">
      <button class="btn btn-sm rounded" @click="clickCopy">
        {{ $t("Buttons.copyPlayLink") }}
      </button>

      <button
        class="btn btn-primary btn-sm rounded"
        @click="showPublishModal = true"
      >
        {{ $t("Buttons.shareToMoments") }}
      </button>
    </div>
    <iframe
      :src="show ? url : 'about:blank'"
      class="w-full h-full overflow-hidden"
    />
  </popup>
  <CreateStoryPublishModal v-model:show="showPublishModal" :story="story" />
</template>
<style>
.van-popup.van-popup--bottom.galgame-preview-popup {
  width: 100%;
  max-width: 100%;
}
</style>
